module.exports = __webpack_public_path__ + "static/finley-book-spanish-8bd9b12c66529b9fc36735dcfcf13f63.jpg";